import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { mediaPhone } from '../styles/breakpoints';

import GreenLineSVG from './GreenLine.svg';
import GreenLineWithIconsSVG from './GreenLineWithIcons.svg';

const IMAGE = {
  default: {
    width: 349,
    height: 42,
    phoneScale: 0.6,
    url: GreenLineSVG,
  },
  withIcons: {
    width: 349,
    height: 140,
    phoneScale: 0.6,
    url: GreenLineWithIconsSVG,
  },
};

const getImage = (small, prop) => IMAGE[small ? 'default' : 'withIcons'][prop];

const Container = styled.div`
  height: ${({ small }) => getImage(small, 'height')}px;
  max-width: 100%;
  overflow: hidden;
`;

const Content = styled.div`
  width: ${({ small }) => getImage(small, 'width')}px;
  height: ${({ small }) => getImage(small, 'height')}px;
  max-width: 100%;

  ${mediaPhone} {
    max-width: ${({ small }) => Math.round(getImage(small, 'width') * getImage(small, 'phoneScale'))}px;
    min-width: 100%;
  }

  margin-left: auto;
  margin-right: auto;

  background-position: ${({ left }) => (left ? 'left' : 'center center')};
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${({ small }) => getImage(small, 'url')});
`;

const Stacheldraht = ({ left, small, className }) => (
  <Container small={small} className={className}>
    <Content small={small} left={left} />
  </Container>
);

Stacheldraht.propTypes = {
  left: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
};

Stacheldraht.defaultProps = {
  left: false,
  small: false,
  className: undefined,
};

export default Stacheldraht;



// WEBPACK FOOTER //
// ./src/components/Stacheldraht/Stacheldraht.js